module.exports = __webpack_public_path__ + "img/kyanite_kyanitelpnft.5181b1e.png";